// BrainContext — the single source of truth for the persistent Brain surface.
// State changes are BEHAVIORS (emphasis of the same surface), never navigation.
import React, { createContext, useContext, useMemo, useReducer } from "react";
import { brainReducer, makeInitialState, ACTIONS, BRAIN_STATES } from "./lib/brainState";

const Ctx = createContext(null);

export function BrainProvider({ children, initial }) {
  const [state, dispatch] = useReducer(brainReducer, undefined, () => makeInitialState(initial));

  const value = useMemo(
    () => ({
      ...state,
      dispatch,
      setState: (s) => dispatch({ type: ACTIONS.SET_STATE, state: s }),
      focusRec: (id) => dispatch({ type: ACTIONS.FOCUS_REC, focusRecId: id }),
      selectNode: (id) => dispatch({ type: ACTIONS.SELECT_NODE, nodeId: id }),
      openConversation: (nodeId) => dispatch({ type: ACTIONS.OPEN_CONVERSATION, nodeId }),
      closeConversation: () => dispatch({ type: ACTIONS.CLOSE_CONVERSATION }),
    }),
    [state]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useBrain() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useBrain must be used within BrainProvider");
  return ctx;
}

export { BRAIN_STATES };
